<div class="component-field-comment show">
	<label
		class="field-comment"
		[class.comment-disabled]="isDisabled"
		[class.comment-touched]="isTouched"
		[class.comment-focused]="isFocused"
		[class.comment-error]="hasError"
		[class.comment-valid]="isValid"
		[class.comment-filled]="hasValue"
	>
		<section class="comment-section-icon">
			@if (isRequired) {
				<lbca-icon
					[class.comment-filled]="hasValue"
					class="comment-light"
					size="small"
					name="lucide:asterisk"
				/>
			}
		</section>
		<section class="comment-section-body">
			<p class="comment-label">
				@if (hasValue && userValue) {
					<span class="text-base text-primary">{{ userValue }}</span>
				}
				@if (hasValue && !userValue) {
					<span class="text-base text-primary">{{ userFullName }}</span>
				}
				@if (!hasValue) {
					<span class="text-sm text-gray-600">{{ labelValue }}</span>
				}
			</p>
			<textarea
				#inputData
				[disabled]="isDisabled"
				class="comment-input"
				type="text"
				[rows]="totalLines"
				(focus)="focusIn()"
				(blur)="focusOut()"
				[placeholder]="placeholder"
				(input)="setValue($event)"
				(keyup)="inputKeyUpEvent($event)"
				>{{ value }}</textarea
			>
			<!-- <div class="comment-focus-marker">&nbsp;</div> -->
			<!--  -->
		</section>
		<section class="comment-section-icon">
			<div class="icon-box comment-icon-validation"></div>
		</section>
	</label>
	@if (enableCount) {
		<section class="comment-section-count">
			@if (helperTextValue) {
				<div class="comment-helper" title="{{ helperTextValue }}">
					{{ helperTextValue }}
				</div>
			}
			<div class="comment-counter" [class.limiterror]="errorCtrl">
				{{ charsControl(inputData.value) }}
			</div>
		</section>
	}
</div>
